import { SET_SOCIALMEDIA } from "../../actions/types/types";

const initState = {
  socialMedia: [],
};

const SocialMediaReducer = (state = initState, action) => {
  switch (action.type) {
    case SET_SOCIALMEDIA:
      return {
        ...state,
        socialMedia: action.payload.data,
      };
    // {console.log(state)}
    default:
      return { ...state };
  }
};

export default SocialMediaReducer;
